import { apiRequest } from './client';
import { getApiToken } from './authToken';

export function fetchCurrentUser(token) {
  return apiRequest('/api/me', { token });
}

export async function patchCurrentUser(patch, token) {
  const authToken = token || (await getApiToken());
  return apiRequest('/api/me', {
    token: authToken,
    method: 'PATCH',
    body: patch,
  });
}
